import { CopyIcon, DownloadIcon, TweetIcon } from '../../assets/icons';
import { useWeb3React } from '@web3-react/core';
import useUserCreatedReferral from '../../hooks/referral/useUserCreatedReferral';
import Button from '../../components/Button';
import { BasePath } from '../../config/constants';
import { download, getReferralLink } from '../../helpers';
import { ShareModalType } from './ShareModal';
import CopyPopUp from '../../components/CopyPopUp';

type ShareActionsProps = {
    type: ShareModalType;
    imageId: string;
    imageBlob: string;
    onClose: () => void;
};

const ShareActions: React.FC<ShareActionsProps> = ({
    type,
    imageId,
    imageBlob,
    onClose,
}) => {
    const { account } = useWeb3React();

    const { userCreatedReferral } = useUserCreatedReferral(account);

    const referralLink = getReferralLink(imageId, userCreatedReferral || '');

    const handleSave = async () => {
        download(imageBlob, `my-${type}-ranking.png`);
    };

    const handleTweet = () => {
        if (!userCreatedReferral) return;

        const params = new URLSearchParams({
            text: `Check out my ${type} ranking on`,
            url: referralLink,
        });
        const url = new URL(`https://twitter.com/intent/tweet?${params.toString()}`);
        window.open(url, 'blank');
    };

    return (
        <div className='actions'>
            {userCreatedReferral ? (
                <>
                    <CopyPopUp
                        copyText={referralLink}
                        trigger={
                            <Button variant='secondary' disabled={!imageId}>
                                Copy
                                <CopyIcon />
                            </Button>
                        }
                    >
                        Copied!
                    </CopyPopUp>

                    <Button
                        variant='secondary'
                        onClick={handleSave}
                        disabled={!imageId || !imageBlob}
                    >
                        Download &nbsp;
                        <DownloadIcon />
                    </Button>
                    <Button onClick={handleTweet} disabled={!imageId}>
                        Tweet &nbsp;
                        <TweetIcon />
                    </Button>
                </>
            ) : (
                <Button internalLink={BasePath.REFERRALS} onClick={onClose}>
                    Generate my referral code
                </Button>
            )}
        </div>
    );
};

export default ShareActions;
